import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Handle } from '../../handle';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-create-tipologia',
  templateUrl: './create-tipologia.component.html',
  styleUrls: ['./create-tipologia.component.scss']
})
export class CreateTipologiaComponent implements OnInit {

  displayedColumns = ['NOMBRE', 'BORRAR'];

  listaSub = [];
  dataSource;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private localSave: LocalSaveService,
    private dialogRef: MatDialogRef<CreateTipologiaComponent>, public Handle: Handle, private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar, private gateway: GatewayService) { }
  operacion = 'createtipologia';
  idtipologia = '';
  idpais;

  ngOnInit() {
    this.idpais = this.data.tipologia.IDPAIS;
    if (this.data.operacion == 'Editar') {
      let SUBS = {
        IDTIPOLOGIA: this.data.tipologia.idtipologia,
        IDPADRE: this.localSave.get('usuarioPGV').IDU,
        IDAREA: this.localSave.get('usuarioPGV').IDAREA
      }
      //console.log(SUBS);
      this.gateway.save('getsubtipologias', SUBS).then((result) => {
        // console.log(this.data.tipologia.nivelcontacto);
        let aux: any = result;
        this.listaSub = aux.rows;
        this.operacion = 'edittipologia';
        this.idtipologia = this.data.tipologia.idtipologia;
        this.grupoVal.controls.NOMBRE.setValue(this.data.tipologia.nombre);
        this.grupoVal.controls.NIVEL.setValue(this.data.tipologia.nivelcontacto);
        this.dataSource = new MatTableDataSource<any>(this.listaSub);
      }
      ).catch(function (e) {
      });
    }
    this.dataSource = new MatTableDataSource<any>(this.listaSub);
  }

  addSubTipologia() {
    let i = 0;
    const index = this.listaSub.findIndex(sub => sub.nombre.toLowerCase() === (this.grupoVal.controls.NOMBRESUB.value.trim()).toLowerCase());
    if (index > -1) {
      this.snackbar.open('Subtipología ya existe', '', {
        duration: 3000
      });
      this.dataSource = new MatTableDataSource<any>(this.listaSub);
    } else {
      this.listaSub.push({ nombre: this.grupoVal.controls.NOMBRESUB.value.trim() });
      this.grupoVal.controls.NOMBRESUB.setValue('');
      this.dataSource = new MatTableDataSource<any>(this.listaSub);
    }
  }

  borrarSub(element) {
    let auxind = -1;
    auxind = this.listaSub.indexOf(element);
    this.listaSub.splice(auxind, 1)
    this.dataSource = new MatTableDataSource(this.listaSub);

    //this.dataSource = new MatTableDataSource<any>(this.listaSub);
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  save() {
    this.spinner.show();
    let TIPOLOGIA = {
      NOMBRE: this.grupoVal.controls.NOMBRE.value.trim(),
      NIVEL: this.grupoVal.controls.NIVEL.value,
      LISTA: this.listaSub,
      IDTIPOLOGIA: this.idtipologia,
      IDPAIS: this.idpais,
      IDPADRE: this.localSave.get('usuarioPGV').IDU,
      IDAREA: this.localSave.get('usuarioPGV').IDAREA
    }
    // console.log('========')
    //   console.log(this.operacion)
    //   console.log(TIPOLOGIA)
    //   console.log('/=/=======')
    this.gateway.save(this.operacion, TIPOLOGIA).then((result) => {
      // console.log('========')
      // console.log(result)
      // console.log('/=/=======')
      this.spinner.hide();
      this.dialogRef.close(true);
    }
    ).catch(function (e) {
    });
  }

  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(60),
      Validators.pattern("[/ a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    NOMBRESUB: new FormControl('', [Validators.compose([
      Validators.minLength(2), Validators.maxLength(60)
      // ,Validators.pattern("['/' a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9 a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    NIVEL: new FormControl('', [Validators.compose([
      Validators.required
    ])]),
  });

  niveles = [
    // { ID: 1, NOMBRE: 'Contacto Efectivo Positivo' },
    // { ID: 2, NOMBRE: 'Contacto Efectivo Negativo' },
    { ID: 0, NOMBRE: 'Contacto' },
    { ID: 3, NOMBRE: 'No Contacto' }

  ];

}
